































































import { defineComponent, reactive, toRefs, PropType, computed, watch } from '@vue/composition-api';

export interface Data {
  inputScale: number
  baseDistance: number
  baseScale: number
  pinchOffsetX: number
  pinchOffsetY: number
  pinchMarginX: number
  pinchMarginY: number
  touchLength: number
  currentDiscription: any
}

export default defineComponent({
  props: {
    base64QuestionImages: {
      type: Array as PropType<string[]>,
      required: true
    },
    selectedPageIdx: {
      type: Number as PropType<number>,
      required: true
    },
    imageWidth: {
      type: Number as PropType<number>,
      required: true
    },
    imageHeight: {
      type: Number as PropType<number>,
      required: true
    },
    height: {
      type: Number as PropType<number>,
      required: true
    },
    direction: {
      type: Number as PropType<number>,
      required: true
    },
    sheet_type: {
      type: Number as PropType<number>,
      required: true
    },
    keyCode: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    title: {
      type: String as PropType<string>,
      default: "問題用紙"
    },
    imageType: {
      type: String as PropType<string>,
      default: "question"
    },
    isDispToggre: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    previewImageType: {
      type: Number as PropType<number>,
      default: 0
    },
    discriptions: {
      required: false,
      default: [],
    },
    badgeText: {
      required: false,
      default: null,
    },
    isDispPaging: {
      required: false,
      default: true,
    },
  },
  setup (props, context) {

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      inputScale: 70,
      baseScale: 0,
      baseDistance: 0,
      pinchOffsetX: 0,
      pinchOffsetY: 0,
      pinchMarginX: 0,
      pinchMarginY: 0,
      touchLength: 0,
      currentDiscription: null,
    });

    /************************************************************
     * 表示中のリンク
     ************************************************************/

     const selectedPageDiscriptions = computed((): any => {
      return props.discriptions.filter(x => x.page == props.selectedPageIdx + 1);
    });

    /************************************************************
     * スライダーの値を倍率に変換
     ************************************************************/

    const scale = computed((): any => {
      return Number(state.inputScale) / 100;
    });
    
    /************************************************************
     * 表示領域の高さ
     ************************************************************/

    const areaHeightStyle = computed((): any => {
      const style: any = {};
      style["height"] = `${props.height - 48}px`;
      return style;
    });

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageWrapStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.imageWidth * scale.value}px`;
      style["height"] = `${props.imageHeight * scale.value}px`;
      return style;
    });

    /************************************************************
     * ページ切り替え
     ************************************************************/

    const pageChanged = (idx: number) => {
      if(idx < 0 || idx + 1 > props.base64QuestionImages.length){
        return;
      }
      context.emit("question-sheet-page-changed", idx);
    }

    /************************************************************
     * 画像上をtouchstart
     ************************************************************/

    const imageAreaTouchstart = (e: TouchEvent) => {
      state.touchLength = e.touches.length;
    }

    /************************************************************
     * ピンチによる拡大縮小
     ************************************************************/

    const imageAreaTouchmove = (e: TouchEvent) => {

      state.touchLength = e.touches.length;

      if(e.touches.length > 1){
        
        e.preventDefault();

        const touches = e.touches;

        const x1 = touches[0].screenX;
        const y1 = touches[0].screenY;

        const x2 = touches[1].screenX;
        const y2 = touches[1].screenY;

        const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        
        if(state.baseDistance){
          const addScale = distance - state.baseDistance;
          
          // 値が低いほど早く拡大縮小する
          const pinchSpeed = 3;

          const newScale = state.baseScale + addScale / pinchSpeed;
          
          if(newScale >= 10 && newScale <= 200){
            state.inputScale = newScale;

            const offsetX = state.pinchOffsetX * scale.value;
            const offsetY = state.pinchOffsetY * scale.value;

            const pageRoot = document.getElementById(`${props.imageType}-page-root-${props.direction}-${props.sheet_type}`);
            pageRoot.scrollLeft = offsetX - state.pinchMarginX;
            pageRoot.scrollTop = offsetY - state.pinchMarginY;
          }
          
        }else{
          state.baseDistance = distance;
          state.baseScale = Number(state.inputScale);
          
          const offsetXs = [];
          const offsetYs = [];

          for(let i = 0; i < 2; i++){
            const touch = e.touches[i];
            const touchElement = touch.target as HTMLElement;
            const bounds = touchElement.getBoundingClientRect();
            offsetXs.push(touch.clientX - window.pageXOffset - bounds.left) 
            offsetYs.push(touch.clientY - window.pageYOffset - bounds.top)
          }

          // 解答用紙原寸大換算のピンチ中心座標取得
          const offsetX1 = offsetXs[0] > offsetXs[1] ? offsetXs[1] : offsetXs[0];
          const offsetX2 = offsetXs[0] > offsetXs[1] ? offsetXs[0] : offsetXs[1];
          const offsetY1 = offsetYs[0] > offsetYs[1] ? offsetYs[1] : offsetYs[0];
          const offsetY2 = offsetYs[0] > offsetYs[1] ? offsetYs[0] : offsetYs[1];
          const offsetX = offsetX1 + ((offsetX2 - offsetX1) / 2);
          const offsetY = offsetY1 + ((offsetY2 - offsetY1) / 2);
          state.pinchOffsetX = offsetX / scale.value;
          state.pinchOffsetY = offsetY / scale.value;

          const rootDiv = document.getElementById(`question-page-root-${props.direction}-${props.sheet_type}`);
          state.pinchMarginX = offsetX - rootDiv.scrollLeft;
          state.pinchMarginY = offsetY - rootDiv.scrollTop;
        }
      }
    }

    /************************************************************
     * 画像上をtouchend
     ************************************************************/

    const imageAreaTouchend = (e: TouchEvent) => {
      state.baseDistance = 0;
      state.touchLength = e.touches.length;
    }

    /****************************************
     * 画像エリアpointerdown
     ****************************************/

     const imageAreaPointerDown = (e: PointerEvent) => {
      state.currentDiscription = null;
    }

    /************************************************************
     * リンクアイコンクリック
     ************************************************************/

     const discriptionClick = (discription: any) => {
      state.currentDiscription = discription;
    }

    /******************************
     * 倍率スライダー
     ******************************/

    watch(() => state.inputScale, (newVal, oldVal) => {

      if(state.touchLength == 0){
        const pageRoot = document.getElementById(`${props.imageType}-page-root-${props.direction}-${props.sheet_type}`);
        const baseOffsetX = (pageRoot.scrollLeft + (pageRoot.offsetWidth / 2)) / (oldVal / 100);
        const baseOffsetY = (pageRoot.scrollTop + (pageRoot.offsetHeight / 2)) / (oldVal / 100);
        const centerX = pageRoot.offsetWidth / 2;
        const centerY = pageRoot.offsetHeight / 2;

        const newOffsetX = baseOffsetX * (Number(newVal) / 100);
        const newOffsetY = baseOffsetY * (Number(newVal) / 100);

        pageRoot.scrollLeft = newOffsetX - centerX;
        pageRoot.scrollTop = newOffsetY - centerY;
      }
    });

    /******************************
     * マウスホイール拡大縮小
     ******************************/

    const imageAreaMousewheel = (e: WheelEvent) => {
      if(props.keyCode == "Control" || e.ctrlKey){
        e.preventDefault();
        const newScale = state.inputScale - (e.deltaY / 30);
        if(newScale >= 10 && newScale <= 200){
          state.inputScale = newScale;
        }
      }
    }

    /******************************
     * 模範解答・問題用紙切り替え
     ******************************/

    const changeImageType = (imageKind: number) => {
      context.emit("change-image-type", imageKind);
    }

    return {
      ...toRefs(state),
      areaHeightStyle,
      imageWrapStyle,
      scale,
      pageChanged,
      imageAreaTouchstart,
      imageAreaTouchmove,
      imageAreaTouchend,
      imageAreaPointerDown,
      discriptionClick,
      imageAreaMousewheel,
      changeImageType,
      selectedPageDiscriptions,
    }
  }
});
